/**
 * Explorers tier built-in shape library — 6 primitives per v2 spec §5.1.
 * Order in the array == order in the panel.
 */

import type { ShapeRef } from '../types.ts';

export const EXPLORERS_SHAPES: ShapeRef[] = [
  {
    id: 'explorers/cube',
    type: 'cube',
    label: 'Cube',
    color: '#FFB627', // Explorers primary amber
    params: { width: 20, height: 20, depth: 20, radius: 0 },
  },
  {
    id: 'explorers/cylinder',
    type: 'cylinder',
    label: 'Cylinder',
    color: '#FF6B6B', // accent coral
    params: { width: 0, height: 20, depth: 0, radius: 10 },
  },
  {
    id: 'explorers/sphere',
    type: 'sphere',
    label: 'Sphere',
    color: '#2EC4B6', // Builders teal — bridges tiers
    params: { width: 0, height: 0, depth: 0, radius: 12 },
  },
  {
    id: 'explorers/cone',
    type: 'cone',
    label: 'Cone',
    color: '#3D5A80', // Designers slate — bridges tiers
    params: { width: 0, height: 24, depth: 0, radius: 12 },
  },
  {
    id: 'explorers/disc',
    type: 'disc',
    label: 'Flat disc',
    color: '#9D4EDD', // friendly violet
    params: { width: 0, height: 4, depth: 0, radius: 16 },
  },
  {
    id: 'explorers/slab',
    type: 'slab',
    label: 'Rectangular slab',
    color: '#06A77D', // friendly green
    params: { width: 30, height: 6, depth: 20, radius: 0 },
  },
];

export const SHAPES_BY_ID: Record<string, ShapeRef> = Object.fromEntries(
  EXPLORERS_SHAPES.map((s) => [s.id, s]),
);
